import { render, staticRenderFns } from "./SettingsEmailTemplates.vue?vue&type=template&id=7ba30029&"
import script from "./SettingsEmailTemplates.vue?vue&type=script&lang=js&"
export * from "./SettingsEmailTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports